// Stub Firebase – không dùng push notification nữa

export const fetchToken = (_setTokenFound: any) => {
    // Không làm gì, luôn coi như không có token
    return Promise.resolve();
};

export const onMessageListener = () =>
    new Promise(resolve => {
        // Không đăng ký listener nào
        resolve(null);
    });